import { useMutation } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { ErrorResponse, MessageErrorResponse } from "../../../requests/@types";
import api from "../api";

const useRequestRlcsQuotaIncrease = ({
  onSuccess
}: {
  onSuccess: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: () => api.requestRLCSQuotaIncrease(),
    onSuccess,
    onError: (
      error: ErrorResponse<
        MessageErrorResponse & { email_not_configured?: boolean }
      >
    ) => {
      if (error.data.email_not_configured) {
        show({
          level: NotificationsLevel.ERROR,
          sticky: true,
          html: true,
          aboveModal: true,
          message:
            'Email is not configured. Please configure SMTP settings on the <a href="/config/">System Configuration</a> page.'
        });
        return;
      }
      show({
        level: NotificationsLevel.ERROR,
        message: error.data.message,
        aboveModal: true
      });
    }
  });

  return { requestQuotaIncrease: mutate, isPending };
};

export default useRequestRlcsQuotaIncrease;
